import React from 'react'
import AuthContainer from 'src/components/layouts/auth-container.component'
import { ButtonDeprecated } from '@honestica/curecall-ui'
import * as Sentry from '@sentry/react'
import { AuthLayout } from 'src/components/layouts/auth-layout.component'
import { CurecallTooltip } from '@honestica/curecall-ui'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface ErrorPageProps {
  children?: React.ReactNode
  eventId?: string
  session?: any
  errorDetail?: string
}

const ErrorReport = ({ children, eventId, errorDetail }: ErrorPageProps) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const { t } = useTranslation()

  const handleRefresh = () => {
    window.location?.replace('/')
  }

  const showReportDialog = (eventId: string) => {
    Sentry.showReportDialog({
      eventId,
      title: t('components.error-report.we-have-problems'),
      subtitle: t('components.error-report.our-team-has-been-informed'),
      subtitle2: t('components.error-report.if-you-want-tell-us-what-happened'),
      labelName: t('components.error-report.name'),
      labelComments: t('components.error-report.what-happened'),
      labelClose: t('components.error-report.close'),
      labelSubmit: t('components.error-report.send'),
      errorGeneric: t('components.error-report.unknown-error-while-sending-message'),
      errorFormEntry: t('components.error-report.thanks-to-fill-all-fields'),
      successMessage: t('components.error-report.your-message-has-been-send-thanks'),
    })
  }

  const clickHereText = () => {
    return (
      <em
        className="c-text-primary c-cursor-pointer hover:c-text-primary-201 c-inline-block"
        onClick={() => {
          errorDetail && navigator.clipboard.writeText(errorDetail)
          setShowTooltip(true)
          setTimeout(() => {
            setShowTooltip(false)
          }, 10000)
        }}
      >
        {t('components.error-report.click-here-to-copy-error-message')}
      </em>
    )
  }

  return (
    <AuthLayout isError>
      <AuthContainer>
        <h2 className="c-w-full c-text-start c-text-2xl c-font-bold c-text-black sm:c-text-start">
          {t('components.error-report.an-error-has-occurred')}
        </h2>
        <p className="c-my-7 c-text-start sm:c-text-start">
          {t('components.error-report.we-know-about-the-problem')} <br />{' '}
          {t('components.error-report.we-work-on-in')}
        </p>

        {errorDetail && (
          <div>
            <div className="c-bg-grey-200 c-rounded-md c-p-2 c-max-h-[80px] c-overflow-scroll c-relative">
              <code className="c-italic">{errorDetail}</code>
            </div>
            <div className="c-block">
              <span>{t('components.error-report.to-help-us-you-can')} </span>
              {showTooltip ? (
                <CurecallTooltip
                  content={t('components.error-report.error-message-copied')}
                  tooltipPosition="bottom"
                  wrapperClassName="tw-inline-block"
                >
                  {clickHereText()}
                </CurecallTooltip>
              ) : (
                clickHereText()
              )}
              <span> {t('components.error-report.and-send-us-with-support')}</span>
            </div>
          </div>
        )}

        {children}

        <div className="c-mt-8">
          <ButtonDeprecated variant="rounded" className=" c-mb-20" size="xl" onClick={handleRefresh}>
            {t('components.error-report.go-to-home')}
          </ButtonDeprecated>
          {eventId ? (
            <div>
              <span className="c-text-sm">
                {t('components.error-report.if-problem-persists')} <br />
                <button
                  className="c-font-semibold c-text-primary-600"
                  onClick={() => showReportDialog(eventId)}
                >
                  {t('components.error-report.tell-us-what-is-going-on')}
                </button>
              </span>
            </div>
          ) : null}
        </div>
      </AuthContainer>
    </AuthLayout>
  )
}

export default ErrorReport
